import { render, staticRenderFns } from "./investigation-stay-manage.vue?vue&type=template&id=73714b1e&scoped=true"
import script from "./investigation-stay-manage.vue?vue&type=script&lang=ts"
export * from "./investigation-stay-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73714b1e",
  null
  
)

export default component.exports